import styled from "styled-components";

export const Container = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  height: 361px;
  min-width: 467px;
  width: 100%;
  background-color: white;

  padding: 32px 77px 47px 29px;
  border-radius: 14px;

  position: relative;
`;

export const Title = styled.p.attrs({})`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.colors.text};
  margin-bottom: 47px;
`;

export const ChartContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 63px;
  width: 100%;
  height: fit-content;

  margin-left: -16px;
`;

export const LegendContainer = styled.div.attrs({})`
  position: absolute;
  top: 87px;
  right: 77px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Legend = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export const LegendLabel = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const LegendText = styled.p.attrs({})`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.colors.text};
  margin-bottom: 0;
`;

export const LegendValue = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const LegendMark = styled.div.attrs({})`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  ${({ customColor }) => !customColor ? `background: linear-gradient(
    to right, 
  #AF00E3 0%, 
  #C800DE 22%, 
  #E600DA 54%, 
  #F800D7 81%, 
  #FF00D6 100%
  ) ` : `background: ${customColor}`};
  
`;

export const Value = styled.p.attrs({})`
  font-size: 24px;
  margin-bottom: 0;
`;